import { Action, combineReducers, createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromPaymentDay from './payment-day.reducer';
import * as fromCutOffDaysForChange from './cut-off-days-for-change.reducer';
import * as fromPaymentMethod from './payment-method.reducer';
import * as fromPaymentRun from './payment-run.reducer';
import * as fromStatement from './statement.reducer';
import * as fromPaymentReprocess from './payment-reprocessor.reducer';
import * as fromPaymentRunMonths from './payment-run-months.reducer';
import * as fromPaymentRunSummary from './payment-run-summary.reducer';
import * as fromBusinessPaymentRun from './business-payment-run.reducer';
import * as fromBusinessPaymentRunDetailProduct from './business-payment-run-detail-product.reducer';
import * as fromBusinessPaymentRunDetailEmployee from './business-payment-run-detail-employee.reducer';
import * as fromBusinessPaymentRunDetailEmployeesByProduct from './business-payment-run-detail-employees-by-product.reducer';
import * as fromAddCreditCard from './add-credit-card.reducer';
import * as fromPaymentRunTabControl from './payment-run-tab-control.reducer';
import * as fromPayrollCalendar from './payroll-calendar.reducer';
import * as fromPaymentRunStatus from './payment-run-status.reducer';
import * as fromUpdatePaymentRun from './update-payment-run.reducer';
import * as fromOutstanding from './outstanding.reducer';
import * as fromIncludePaymentRun from './include-payment-run.reducer';
import * as fromNotifyIndividual from './notify-individual.reducer';
import * as fromGenerateRefundStatement from './generate-refund-statement.reducer';
import * as fromClosePaymentRun from './close-payment-run.reducer';
import * as fromRollbackPaymentRun from './rollback-payment-run.reducer';
import * as fromNotifyOutstanding from './notify-outstanding.reducer';

export const paymentsAndStatementsFeatureKey = 'payments';

export interface PaymentsAndStatementsState {
  [fromPaymentDay.paymentDayFeatureKey]: fromPaymentDay.State;
  [fromPayrollCalendar.payrollCalendarFeatureKey]: fromPayrollCalendar.State;
  [fromCutOffDaysForChange.cutOffDaysForChangeKey]: fromCutOffDaysForChange.State;
  [fromPaymentMethod.paymentMethodFeatureKey]: fromPaymentMethod.State;
  [fromPaymentRun.paymentRunFeatureKey]: fromPaymentRun.State;
  [fromPaymentRunSummary.paymentRunSummaryFeatureKey]: fromPaymentRunSummary.State;
  [fromStatement.statementFeatureKey]: fromStatement.State;
  [fromPaymentReprocess.paymentReprocessorFeatureKey]: fromPaymentReprocess.State;
  [fromPaymentRunMonths.paymentRunMonthsFeatureKey]: fromPaymentRunMonths.PaymentRunMonthsState;
  [fromBusinessPaymentRun.businessPaymentRunFeatureKey]: fromBusinessPaymentRun.BusinessPaymentRunState;
  [fromBusinessPaymentRunDetailProduct.businessPaymentRunDetailProductFeatureKey]: fromBusinessPaymentRunDetailProduct.BusinessPaymentRunDetailProductState;
  [fromBusinessPaymentRunDetailEmployee.businessPaymentRunDetailEmployeeFeatureKey]: fromBusinessPaymentRunDetailEmployee.BusinessPaymentRunDetailEmployeeState;
  [fromBusinessPaymentRunDetailEmployeesByProduct.businessPaymentRunDetailEmployeesByProductFeatureKey]: fromBusinessPaymentRunDetailEmployeesByProduct.BusinessPaymentRunDetailEmployeesByProductState;
  [fromAddCreditCard.addCreditCardFeatureKey]: fromAddCreditCard.State;
  [fromPaymentRunTabControl.paymentRunTabControlFeatureKey]: fromPaymentRunTabControl.PaymentRunTabControlState;
  [fromPaymentRunStatus.paymentRunStatusFeatureKey]: fromPaymentRunStatus.PaymentRunStatusState;
  [fromUpdatePaymentRun.updatePaymentRunFeatureKey]: fromUpdatePaymentRun.UpdatePaymentRunState;
  [fromOutstanding.outstandingFeatureKey]: fromOutstanding.OutstandingState;
  [fromIncludePaymentRun.includePaymentRunFeatureKey]: fromIncludePaymentRun.IncludePaymentRunState;
  [fromNotifyIndividual.notifyIndividualFeatureKey]: fromNotifyIndividual.NotifyIndividualState;
  [fromGenerateRefundStatement.generateRefundStatementFeatureKey]: fromGenerateRefundStatement.GenerateRefundStatementState;
  [fromClosePaymentRun.closePaymentRunFeatureKey]: fromClosePaymentRun.ClosePaymentRunState;
  [fromRollbackPaymentRun.rollbackPaymentRunFeatureKey]: fromRollbackPaymentRun.RollbackPaymentRunState;
  [fromNotifyOutstanding.notifyOutstandingFeatureKey]: fromNotifyOutstanding.NotifyOutstandingState;
}

export interface State {
  [paymentsAndStatementsFeatureKey]: PaymentsAndStatementsState;
}

export function reducers(state: PaymentsAndStatementsState | undefined, action: Action) {
  return combineReducers({
    [fromPaymentDay.paymentDayFeatureKey]: fromPaymentDay.reducer,
    [fromPayrollCalendar.payrollCalendarFeatureKey]: fromPayrollCalendar.reducer,
    [fromCutOffDaysForChange.cutOffDaysForChangeKey]: fromCutOffDaysForChange.reducer,
    [fromPaymentMethod.paymentMethodFeatureKey]: fromPaymentMethod.reducer,
    [fromPaymentRun.paymentRunFeatureKey]: fromPaymentRun.reducer,
    [fromPaymentRunSummary.paymentRunSummaryFeatureKey]: fromPaymentRunSummary.reducer,
    [fromStatement.statementFeatureKey]: fromStatement.reducer,
    [fromPaymentReprocess.paymentReprocessorFeatureKey]: fromPaymentReprocess.reducer,
    [fromPaymentRunMonths.paymentRunMonthsFeatureKey]: fromPaymentRunMonths.reducer,
    [fromBusinessPaymentRun.businessPaymentRunFeatureKey]: fromBusinessPaymentRun.reducer,
    [fromBusinessPaymentRunDetailProduct.businessPaymentRunDetailProductFeatureKey]: fromBusinessPaymentRunDetailProduct.reducer,
    [fromBusinessPaymentRunDetailEmployee.businessPaymentRunDetailEmployeeFeatureKey]: fromBusinessPaymentRunDetailEmployee.reducer,
    [fromBusinessPaymentRunDetailEmployeesByProduct.businessPaymentRunDetailEmployeesByProductFeatureKey]:
      fromBusinessPaymentRunDetailEmployeesByProduct.reducer,
    [fromAddCreditCard.addCreditCardFeatureKey]: fromAddCreditCard.reducer,
    [fromPaymentRunTabControl.paymentRunTabControlFeatureKey]: fromPaymentRunTabControl.reducer,
    [fromPaymentRunStatus.paymentRunStatusFeatureKey]: fromPaymentRunStatus.reducer,
    [fromUpdatePaymentRun.updatePaymentRunFeatureKey]: fromUpdatePaymentRun.reducer,
    [fromOutstanding.outstandingFeatureKey]: fromOutstanding.outstandingReducer,
    [fromIncludePaymentRun.includePaymentRunFeatureKey]: fromIncludePaymentRun.includePaymentRunReducer,
    [fromNotifyIndividual.notifyIndividualFeatureKey]: fromNotifyIndividual.notifyIndividualReducer,
    [fromGenerateRefundStatement.generateRefundStatementFeatureKey]: fromGenerateRefundStatement.generateRefundStatementReducer,
    [fromClosePaymentRun.closePaymentRunFeatureKey]: fromClosePaymentRun.closePaymentRunReducer,
    [fromRollbackPaymentRun.rollbackPaymentRunFeatureKey]: fromRollbackPaymentRun.rollbackPaymentRunReducer,
    [fromNotifyOutstanding.notifyOutstandingFeatureKey]: fromNotifyOutstanding.notifyOutstandingReducer
  })(state, action);
}

export const selectPaymentsAndStatementsState = createFeatureSelector<State, PaymentsAndStatementsState>(paymentsAndStatementsFeatureKey);

export const selectPaymentDayEntitiesState = createSelector(
  selectPaymentsAndStatementsState,
  state => state[fromPaymentDay.paymentDayFeatureKey]
);

export const selectPayrollCalendarEntitiesState = createSelector(
  selectPaymentsAndStatementsState,
  state => state[fromPayrollCalendar.payrollCalendarFeatureKey]
);

export const selectCutOffDaysForChangeEntitiesState = createSelector(
  selectPaymentsAndStatementsState,
  state => state[fromCutOffDaysForChange.cutOffDaysForChangeKey]
);

export const selectPaymentMethodsEntitiesState = createSelector(
  selectPaymentsAndStatementsState,
  state => state[fromPaymentMethod.paymentMethodFeatureKey]
);

export const selectPaymentRunSummaryState = createSelector(
  selectPaymentsAndStatementsState,
  state => state[fromPaymentRunSummary.paymentRunSummaryFeatureKey]
);

export const selectPaymentRunsEntitiesState = createSelector(
  selectPaymentsAndStatementsState,
  state => state[fromPaymentRun.paymentRunFeatureKey]
);

export const selectStatementEntitiesState = createSelector(
  selectPaymentsAndStatementsState,
  state => state[fromStatement.statementFeatureKey]
);

export const selectReprocessPaymentState = createSelector(
  selectPaymentsAndStatementsState,
  state => state[fromPaymentReprocess.paymentReprocessorFeatureKey]
);

export const selectAddCreditCardState = createSelector(
  selectPaymentsAndStatementsState,
  state => state[fromAddCreditCard.addCreditCardFeatureKey]
);

export const selectPaymentRunMonthsState = createSelector(
  selectPaymentsAndStatementsState,
  state => state[fromPaymentRunMonths.paymentRunMonthsFeatureKey]
);

export const selectBusinessPaymentRunState = createSelector(
  selectPaymentsAndStatementsState,
  state => state[fromBusinessPaymentRun.businessPaymentRunFeatureKey]
);

export const selectBusinessPaymentRunDetailProductState = createSelector(
  selectPaymentsAndStatementsState,
  state => state[fromBusinessPaymentRunDetailProduct.businessPaymentRunDetailProductFeatureKey]
);
export const selectBusinessPaymentRunDetailEmployeeState = createSelector(
  selectPaymentsAndStatementsState,
  state => state[fromBusinessPaymentRunDetailEmployee.businessPaymentRunDetailEmployeeFeatureKey]
);
export const selectBusinessPaymentRunDetailEmployeesByProductState = createSelector(
  selectPaymentsAndStatementsState,
  state => state[fromBusinessPaymentRunDetailEmployeesByProduct.businessPaymentRunDetailEmployeesByProductFeatureKey]
);

export const selectPaymentRunTabControlState = createSelector(
  selectPaymentsAndStatementsState,
  state => state[fromPaymentRunTabControl.paymentRunTabControlFeatureKey]
);

export const selectPaymentRunStatusState = createSelector(
  selectPaymentsAndStatementsState,
  state => state[fromPaymentRunStatus.paymentRunStatusFeatureKey]
);

export const selectUpdatePaymentRunState = createSelector(
  selectPaymentsAndStatementsState,
  state => state[fromUpdatePaymentRun.updatePaymentRunFeatureKey]
);

export const selectOutstandingState = createSelector(
  selectPaymentsAndStatementsState,
  state => state[fromOutstanding.outstandingFeatureKey]
);
